import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import '../translate';
import '../translate/translate';
import '../styles/NavbarPanel.css';
import '../styles/ProfileModal.css';
import { useAuth } from "../providers/AuthProvider.jsx";
import { Navigate, useNavigate } from "react-router-dom";

function NavbarPanel({ setIsNavbarPanelOpen, setIsProfileOpen, setIsDetailOpen, setIsDepositOpen, setIsWithdrawOpen, setIsNotificationsOpen }) {
    const { setIsAuthenticated, user } = useAuth()
    const navigate = useNavigate()
    const { t } = useTranslation();
    const [mainWallet, setMainWallet] = useState(null)
    const [userId, setUserId] = useState(null)
    const [userBalance, setUserBalance] = useState(null)

    useEffect(() => {
        if (user) {
            setMainWallet(user.mainWallet);
            setUserId(user.id);
            setUserBalance(user[`${user.mainWallet}Balance`])
        }
    }, [user])

    const logout = () => {
        localStorage.removeItem("token");
        setIsAuthenticated(false)
        navigate('/login')
    }

    

    return (
        <div className={'profile-modal-wrapper'}>
            <div className={'navbar-panel-wrapper'}>
                <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsNavbarPanelOpen(false)}/>
                <div className={'profile-modal-title'}>
                    <span>ID #{userId ? 120000 + userId : ""}</span>
                </div>
                <div className={'navbar-panel-wallet-wrapper'}>
                    <span style={{"font-size": "12px",}}>{t("main_page_balance_amount")}</span>
                    <div className={'navbar-panel-wallet-container'}>
                        <span style={{"font-size": "16px", "font-weight": "bold",}}>{mainWallet ? mainWallet.toUpperCase() : ""}</span>
                        <span style={{"border": "1px solid #d9d9d9", "height": "14px", "margin" : "0 7px"}}></span>
                        <span style={{"font-size": "14px"}}>{userBalance ? userBalance : ""}</span>
                    </div>
                </div>
                <div className={'profile-modal-language-wrapper'}>
                    
                </div>
                {/* <div className={'navbar-panel-deposit-buttons'}>
                    <div className={'navbar-panel-deposit-button'}>
                        <img src="/assets/img/main/deposit-plus.svg" alt="" />
                        <p>Deposit</p>
                    </div>
                    <div className={'navbar-panel-deposit-button withdraw'}>
                        <img src="/assets/img/main/deposit-minus.svg" alt="" />
                        <p>Withdraw</p>
                    </div>
                </div> */}
                <div className={'navbar-panel-list'}>
                    <div className={'navbar-panel-item'} onClick={() => setIsProfileOpen(true)}>
                        <img src="/assets/img/main/profile-icon.svg" alt="" />
                        <span style={{"height": "25px", "margin": "0 10px", "border": "1px solid #d9d9d9"}}></span>
                        <span style={{"font-size": "18px", "font-weight": "700"}}>{t("mp_profile")}</span>
                    </div>


                    <div className={'navbar-panel-item'} onClick={() => setIsDepositOpen(true)}>
                        <img src="/assets/img/main/deposit.svg" alt="" />
                        <span style={{"height": "25px", "margin": "0 10px", "border": "1px solid #d9d9d9"}}></span>
                        <span style={{"font-size": "18px", "font-weight": "700"}}>{t("mp_deposit")}</span>
                    </div>


                    <div className={'navbar-panel-item'} onClick={() => setIsWithdrawOpen(true)}>
                        <img src="/assets/img/main/withdraw.svg" alt="" />
                        <span style={{"height": "25px", "margin": "0 10px", "border": "1px solid #d9d9d9"}}></span>
                        <span style={{"font-size": "18px", "font-weight": "700"}}>{t("mp_withdraw")}</span>
                    </div>


                    <div className={'navbar-panel-item'} onClick={() => setIsDetailOpen(true)}>
                        <img src="/assets/img/main/details.svg" alt="" />
                        <span style={{"height": "25px", "margin": "0 10px", "border": "1px solid #d9d9d9"}}></span>
                        <span style={{"font-size": "18px", "font-weight": "700"}}>{t("mp_detail")}</span>
                    </div>


                    <div className={'navbar-panel-item'} onClick={() => setIsNotificationsOpen(true) }>
                        <img src="/assets/img/main/notification.svg" alt="" />
                        <span style={{"height": "25px", "margin": "0 10px", "border": "1px solid #d9d9d9"}}></span>
                        <span style={{"font-size": "18px", "font-weight": "700"}}>{t("mp_notifications")}</span>
                    </div>

                    <div className={'navbar-panel-item'} onClick={() => {
                        window.location.href = 'https://t.me/aviatorwinn_support';
                    }}>
                        <img src="/assets/img/main/support.svg" alt="" />
                        <span style={{"height": "25px", "margin": "0 10px", "border": "1px solid #d9d9d9"}}></span>
                        <span style={{"font-size": "18px", "font-weight": "700"}}>{t("mp_support")}</span>
                    </div>
                </div>
                <div className={'logout-button'} onClick={() => logout()}>
                    {t("mp_logout")}
                </div>

                
            </div>
        </div>
    )
}

export default NavbarPanel